/**
 * OwnYou Typography System — Sprint 14 Production Design System
 *
 * Type scale from display through small. Uses system font stack
 * for optimal rendering across platforms.
 *
 * @see docs/sprints/ownyou-sprint14-spec.md Package 1
 */
/**
 * Typography scale presets
 */
export const typography = {
    display: { size: '2.25rem', weight: 700, leading: 1.2, tracking: '-0.02em' },
    heading: { size: '1.5rem', weight: 600, leading: 1.3, tracking: '-0.01em' },
    subhead: { size: '1.125rem', weight: 500, leading: 1.4, tracking: '0' },
    body: { size: '1rem', weight: 400, leading: 1.5, tracking: '0' },
    caption: { size: '0.875rem', weight: 400, leading: 1.4, tracking: '0.01em' },
    small: { size: '0.75rem', weight: 400, leading: 1.4, tracking: '0.02em' },
};
/**
 * Font family definitions
 */
export const fontFamily = {
    /** System sans-serif stack for body/UI text */
    sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    /** Monospace for code/data */
    mono: '"SF Mono", "Fira Code", "Fira Mono", "Roboto Mono", monospace',
};
/**
 * CSS custom property tokens for typography
 */
export const typographyTokens = {
    '--font-sans': fontFamily.sans,
    '--font-mono': fontFamily.mono,
};
//# sourceMappingURL=typography.js.map